export default function logEvent(eventType, eventProperties = {}, callback) {
  document.dispatchEvent(new CustomEvent('AmplitudeLogEvent', {
    detail:  { eventType, eventProperties, callback },
    bubbles: true
  }));
}
